var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.currentRouteComponent,_vm._g(_vm._b({tag:"component",attrs:{"route-index":_vm.routeIndex,"routes":_vm.routes,"can-go-back":_vm.canGoBackComputed},on:{"go-back":_vm.goBack,"advance":_vm.advance,"close":_vm.close,"complete":_vm.complete}},'component',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }